/**
 * HospitalTabs - Tab navigation for hospital page
 */
import React from 'react';

export type HospitalTabType = 'dados-gerais' | 'locais' | 'representantes';

interface HospitalTabsProps {
  activeTab: HospitalTabType;
  setActiveTab: (tab: HospitalTabType) => void;
}

const tabs: { id: HospitalTabType; label: string }[] = [
  { id: 'dados-gerais', label: 'Dados Gerais' },
  { id: 'locais', label: 'Locais de Contagem' },
  { id: 'representantes', label: 'Representantes' },
];

export const HospitalTabs: React.FC<HospitalTabsProps> = ({
  activeTab,
  setActiveTab,
}) => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow border border-gray-200 dark:border-gray-700">
      <div className="flex px-6">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-4 py-3 text-sm font-medium border-b-2 ${
              activeTab === tab.id
                ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};
